import { Observable } from "rxjs";

export class ValidationError {
    constructor(readonly messageKey: string, readonly params: { [name: string]: any } = {}) {}
}

export class FieldValidationError extends ValidationError{
    constructor(readonly messageKey: string, readonly field?: FieldName, readonly params: { [name: string]: any } = {}) {
        super(messageKey, params);
    }
}

export type FieldName = string | Observable<string>